import { call, put } from "redux-saga/effects";
import { fetchAssetsSuccess } from "../../assets/assetsActions";
import { getAssets } from "../requests/assets";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

export function* handleFetchAssets() {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(getAssets, "");
    yield put(fetchAssetsSuccess(parseServiceToHelpAssets(response)));
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(error);
    yield put(stopLoadingIndicator());
  }
}

const parseServiceToHelpAssets = (response) => {
  let obj = { familyOffer: {} };
  if (response?.data?.data) {
    obj = {
      ...obj,
      familyOffer: {
        en: {
          image: response.data.data["family_offer_card_bg_en"]?.data.full_url,
          defaultImage:
            response.data.data["family_offer_card_default_bg_en"]?.data
              .full_url,
        },
        ar: {
          image: response.data.data["family_offer_card_bg_ar"]?.data.full_url,
          defaultImage:
            response.data.data["family_offer_card_default_bg_ar"]?.data
              .full_url,
        },
        barcodeImg:
          response.data.data["family_offer_barcode_img"]?.data.full_url,
      }
    };
  }
  return obj;
};
